import { makeAutoObservable } from "mobx";
import { onError } from "@/utils/onError";
import { TableSelectStore } from "@/components/TableSelect/TableSelectStore";
import { DataTableStore } from "./DataTableStore";
import { SearchFilter } from "@/components/filters";
export class SingleChargingStationStore {
    constructor(chargingStationService, chargingStationModelService) {
        this.chargingStationService = chargingStationService;
        this.chargingStationModelService = chargingStationModelService;
        this.station = null;
        this.loading = false;
        this.modelSelectStore = null;
        makeAutoObservable(this);
    }
    setStation(station) {
        this.station = station;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setModelSelectStore(modelSelectStore) {
        this.modelSelectStore = modelSelectStore;
    }
    async init(stationId) {
        this.setLoading(true);
        try {
            // Сначала загружаем станцию
            const stations = stationId
                ? await this.chargingStationService.getStationsByIds([stationId])
                : null;
            this.setStation(stations?.[0] || null);
            // Потом создаем TableSelect (теперь this.station уже загружена)
            this.setModelSelectStore(new TableSelectStore(new DataTableStore({
                dataLoader: {
                    loadData: (params) => this.chargingStationModelService.getModelsWithParams(params),
                },
            }), {
                dataLoader: () => this.station
                    ? this.chargingStationModelService.getModelsByIds([
                        this.station.idChargingStationModel,
                    ])
                    : Promise.resolve([]),
            }, [
                {
                    id: "model-search-filter",
                    Cmp: SearchFilter,
                    props: {
                        name: "search",
                        label: "Поиск",
                        placeholder: "Поиск по названию модели...",
                        allowClear: true,
                        showSearchIcon: true,
                        onChange: (value) => this.modelSelectStore?.filterStore?.updateFilter("search", value),
                    },
                    visible: true,
                    order: 1,
                },
            ]));
        }
        catch (error) {
            onError(error, "Error initializing charging station");
        }
        finally {
            this.setLoading(false);
        }
    }
    async saveStation(stationData) {
        try {
            this.setLoading(true);
            let result;
            if (this.station) {
                result = await this.chargingStationService.updateStation(this.station.id, stationData);
            }
            else {
                result = await this.chargingStationService.createStation(stationData);
            }
            this.setStation(result);
            return result;
        }
        catch (error) {
            onError(error, "Error saving charging station");
            return null;
        }
        finally {
            this.setLoading(false);
        }
    }
    async deleteStation(stationId) {
        try {
            this.setLoading(true);
            await this.chargingStationService.deleteStation(stationId);
        }
        catch (error) {
            onError(error, "Error deleting charging station");
        }
        finally {
            this.setLoading(false);
        }
    }
    clearStationData() {
        this.setStation(null);
        this.modelSelectStore?.reset();
        this.setLoading(false);
    }
}
